import React from 'react';

const SvgIl = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="IL_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="IL_svg__b" fill="#fff">
        <use xlinkHref="#IL_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path
        fill="#0E46D4"
        mask="url(#IL_svg__b)"
        d="M0 0h28v4H0zM0 16h28v4H0z"
      />
      <path
        d="M9.566 10.547l6.887-4.13-.132 8.03-6.755-3.9z"
        stroke="#093EC5"
        strokeWidth={0.667}
        mask="url(#IL_svg__b)"
        transform="rotate(-30 13.167 10.443)"
      />
      <path
        d="M9.566 9.66l6.887-4.13-.132 8.03-6.755-3.9z"
        stroke="#093EC5"
        strokeWidth={0.667}
        mask="url(#IL_svg__b)"
        transform="scale(1 -1) rotate(-30 -22.5 0)"
      />
    </g>
  </svg>
);

export default SvgIl;
